import MUIListItem from "@mui/material/ListItem";

export const ListItem = MUIListItem;

export default ListItem;
